import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useFormDetails } from "../../../Constant/apiHooks";
import { LoadingComponent } from "../../../Components";
import {
  FORM_BUILDER_FORM_DETAILS_APPLICATION_URL,
  FORM_BUILDER_FORM_APPLICATION_URL,
  FORM_BUILDER_FORM_AUTO_SAVE_URL,
  FORM_BUILDER_FORM_APP_SUBMIT_URL,
  CREATE_FORM_APPLICATION_URL,
} from "../../../Constant/api";
import { authService } from "../../../Service/Axios";
import { toast } from "react-toastify";
import { alphanumericRegex, emailRegx, nameRegex } from "../../../Utils/regex";
import Application from "./Application";

const FormApplication = () => {
  const { search } = useLocation();
  const { formId } = useParams();
  const queryParams = `${search.split("?")[1]}`;

  const { formDetails, loading: formDetailsLoading } = useFormDetails(
    formId,
    queryParams
  );

  const [first, setfirst] = useState([]);
  const [viewForm, setviewForm] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [appID, setappID] = useState("");

  const viewFormAction = async () => {
    const payload = { formId: formId, urlParameter: queryParams, appId: appID };
    const response = await authService(
      FORM_BUILDER_FORM_DETAILS_APPLICATION_URL,
      "POST",
      payload
    );
    if (response) {
      setappID(response.appId)
      setviewForm(response);
      let temp = [];
      response?.pages?.forEach((i) => {
        i?.sections?.forEach((el) => {
          el?.questions?.forEach((item) => {
            temp.push({
              sectionId: item?.sectionId,
              questionId: item?.questionId,
              value: item?.value,
              choiceGroupKeyValue: item?.choiceGroupKeyValue,
            });
          });
        });
      });
      setfirst(temp);
    }
  };

  const autoSaveForm = async (data, id, flag) => {
    const payload = {
      formId: formId,
      fieldDetails: data,
      appId: id,
    };
    const response = await authService(
      FORM_BUILDER_FORM_AUTO_SAVE_URL,
      "POST",
      payload
    );
    if (response) {
      setappID(response.appId);
    }
    //temporary
    submitApplicationForm(data, appID, flag);
  };

  const OtherCalc = (viewForm, item, ans) => {
    const mp = new Map();
    viewForm?.pages?.forEach((itm) =>
      itm.sections?.forEach((ele) =>
        ele.questions?.forEach((i) =>
          mp.set(
            i.questionName,
            i.dropdownValues.length > 0
              ? i.dropdownValues
                .filter((it) => i.value.includes(it.key))
                ?.map((el) => el.value)
              : i.value
          )
        )
      )
    );
    let flag = [];
    item?.calulateOthersCond?.forEach((ele) => {
      if (ele.condition == "AND") {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name)?.sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        }
      } else if (ele.condition == "OR" && flag[flag.length - 1].val == false) {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = false;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = false;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        }
      }
    });

    for (let i = 0; i < flag.length; i++) {
      if (flag[i].op == "AND") ans = ans && flag[i].val;
      else ans = ans || flag[i].val;
    }

    if (flag.length > 0) return ans;
    else return false;
  };

  const findCalc = (viewForm) => {
    const mpR = new Map();
    viewForm?.pages?.forEach((itm) =>
      itm.sections?.forEach((ele) =>
        ele.questions?.forEach((i) => {
          let k = i.value?.length == 0 ? "0" : i.value[0]?.length > 0 ?
            i.calculateValueType == "Day" ? new Date(i.value[0]).getDate().toString() :
              i.calculateValueType == "Month" ? new Date(i.value[0]).getMonth().toString() :
                i.calculateValueType == "Year" ? new Date(i.value[0]).getFullYear().toString() :
                  i.calculateValueType == "Minute" ? parseInt(i.value[0].split(":")[0] * 60) + parseInt((i.value[0].split(":")[1])) :
                    i.calculateValueType == "Hour" ? parseInt(i.value[0].split(":")[1] / 60) + parseInt(i.value[0].split(":")[0]) :
                      i.value[0] : "0";
          mpR.set(i.questionName, k);
        })
      )
    );
    let boolCalculation = false;
    viewForm?.pages?.map((i) => {
      i?.sections?.map((el) =>
        el?.questions?.filter((item) => {
          if (item.calculate) boolCalculation = item.calculate;
        })
      );
    });

    if (boolCalculation) {
      viewForm?.pages?.forEach((itm) =>
        itm.sections?.forEach((ele) =>
          ele.questions?.forEach((item) => {
            if (item?.calculateType == "Date calculation" ||
              item?.calculateType == "Time calculation" ||
              item?.calculateType == "Number calculation") {
              let q = "";
              let x = item?.calculateType
              let y = item?.calculateValueType
              item?.calculation?.expersion
                ?.trim()
                ?.split(" ")
                ?.forEach((i) => {
                  if (i == "current" && x == "Time calculation") {
                    if (y == "Hour") q = q + new Date().getHours()
                    else if (y == "Minute") q = q + new Date().getMinutes()
                  } else if (i == "current" && x == "Date calculation") {
                    if (y == "Day") q = q + new Date().getDay()
                    else if (y == "Month") q = q + new Date().getMonth()
                    else if (y == "Year") q = q + new Date().getFullYear()
                  } else if (mpR.get(i) && q.length > 0) {
                    q = q + mpR.get(i);
                  } else if (!mpR.get(i) && q.length > 0 && i.length == 1) {
                    q = q + i;
                  } else if (mpR.get(i)) {
                    q = mpR.get(i);
                  }
                });

              autoSaveForm(
                [
                  ...first
                    .filter((it) => it?.questionId == item?.questionId)
                    ?.map((el) => {
                      return {
                        ...el,
                        value: [eval(q)],
                      };
                    }),
                  ...first.filter((it) => it?.questionId != item?.questionId),
                ],
                appID, viewForm.mandatory
              );
            }
            else if (item?.calculateType == "Other calculation") {
              if (OtherCalc(viewForm, item, true)) {
                if (item?.typename == "drop_on" ||
                  item?.typename == "mutiple_on" ||
                  item?.typename == "toggle_on" ||
                  item?.typename == "check_on") {
                  autoSaveForm(
                    [
                      ...first
                        .filter((it) => it?.questionId == item?.questionId)
                        ?.map((el) => {
                          return {
                            ...el,
                            value: item?.calulateOthersMultiSelect?.map(i => i.key),
                          };
                        }),
                      ...first.filter((it) => it?.questionId != item?.questionId),
                    ],
                    appID, viewForm.mandatory
                  );
                }
                else {
                  autoSaveForm(
                    [
                      ...first
                        .filter((it) => it?.questionId == item?.questionId)
                        ?.map((el) => {
                          return {
                            ...el,
                            value: [item?.calulateOthersValue],
                          };
                        }),
                      ...first.filter((it) => it?.questionId != item?.questionId),
                    ],
                    appID, viewForm.mandatory
                  );
                }
              }
              else {
                autoSaveForm(
                  [
                    ...first
                      .filter((it) => it?.questionId == item?.questionId)
                      ?.map((el) => {
                        return {
                          ...el,
                          value: [],
                        };
                      }),
                    ...first.filter((it) => it?.questionId != item?.questionId),
                  ],
                  appID, viewForm.mandatory
                );
              }
            }
          })
        )
      );
    }
    else {
      autoSaveForm(first, appID, viewForm.mandatory);
    }
  };

  const submitApplicationForm = async (data, id, flag) => {
    const newArr = viewForm?.pages?.map((i) => {
      return {
        ...i,
        sections: i?.sections?.map((el) => {
          return {
            ...el,
            questions: el?.questions?.map((item) => {
              return {
                ...item,
                value: data.filter((i) => i.questionId == item.questionId)[0]
                  ?.value,
              };
            }),
          };
        }),
      };
    });

    const payload = {
      formId: viewForm?.formId,
      formName: viewForm?.formName,
      description: viewForm?.description,
      status: "In Progress",
      pages: newArr,
      appId: viewForm?.appId ? viewForm?.appId : id,
      mandatory: flag
    };
    const response = await authService(
      CREATE_FORM_APPLICATION_URL,
      "POST",
      payload
    );
    setviewForm(response);
  };
  const [subFlag, setsubFlag] = useState(false)
  const saveFormApplication = async (data) => {
    const payload = {
      formId: formId,
      fieldDetails: data,
      appId: viewForm?.appId ? viewForm?.appId : appID,
    };
    const response = await authService(
      FORM_BUILDER_FORM_APPLICATION_URL,
      "POST",
      payload
    );
    if (response) {
      if (!response.success) {
        toast.error(response.message);
      } else {
        setsubFlag(response.success)
        toast.success("Form submitted.");
        setModalShow(true);
        setwaits(false)
      }
      //viewFormAction();
    }
  };

  useEffect(() => {
    if (first.length == 0) viewFormAction();
    else if (viewForm?.status != "Submitted") {
      const delayDebounceFn = setTimeout(() => {
        findCalc(viewForm);
        // autoSaveForm(first, appID)
      }, 30000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [first]);

  const retFind = (viewForm, item, ans) => {
    const mp = new Map();
    viewForm?.pages?.forEach((itm) =>
      itm.sections?.forEach((ele) =>
        ele.questions?.forEach((i) =>
          mp.set(
            i.questionName,
            i.dropdownValues.length > 0
              ? i.dropdownValues
                .filter((it) => i.value.includes(it.key))
                ?.map((el) => el.value)
              : i.value
          )
        )
      )
    );
    let flag = [];
    item?.mainConditions?.forEach((ele) => {
      if (ele.condition == "AND") {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name)?.sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        }
      } else if (ele.condition == "OR" && flag[flag.length - 1].val == false) {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = false;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = false;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        }
      }
    });

    for (let i = 0; i < flag.length; i++) {
      if (flag[i].op == "AND") ans = ans && flag[i].val;
      else ans = ans || flag[i].val;
    }

    if (flag.length > 0) return ans;
    else return false;
  };

  const [waits, setwaits] = useState(false)
  const handleApplicationSave = (e) => {
    e.preventDefault();
    let unique = [],
      maxi = [],
      mini = [],
      negi = [],
      alphab = [],
      alphanum = [],
      ints = [],
      deci = [],
      beta = [],
      maxiA = [],
      miniA = [],
      maxiB = [],
      miniB = [];

    let newFormView = { ...viewForm, mandatory: true };

    newFormView?.pages?.forEach((ele) => {
      ele.sections?.forEach((i) => {
        if (i.addrule ? i.show && retFind(viewForm, i, true) : true) {
          i.questions?.forEach((item) => {
            if (
              item.addrule ? item.show && retFind(viewForm, item, true) : true
            ) {
              if (item.required) {
                if (item.typename == "emails") {
                  unique.push(
                    item.value.length > 0 && item.value[0].match(emailRegx)
                      ? item.value[0]
                      : ""
                  );
                } else {
                  unique.push(item.value.length > 0 ? item.value[0] : "");
                }
              }
              if (item?.validation) {
                if (item.maximumLength > 0)
                  maxi.push(
                    item.value[0]?.length <= item.maximumLength
                      ? item.value[0]
                      : ""
                  );
                if (item.minimumLength > 0)
                  mini.push(
                    item.value[0]?.length >= item.minimumLength
                      ? item.value[0]
                      : ""
                  );
                if (item.dropdownDeafultValueCheck)
                  negi.push(item.value[0] < 0 ? item.value[0] : "");
                if (item.dropdownapi == "Alphabet")
                  alphab.push(
                    nameRegex.test(item.value[0]) ? item.value[0] : ""
                  );
                if (item.dropdownapi == "Alphanumeric")
                  alphanum.push(
                    alphanumericRegex.test(item.value[0]) ? item.value[0] : ""
                  );
                if (item.numericValue == "integer")
                  ints.push(
                    Number.isInteger(Number(item.value[0])) ? item.value[0] : ""
                  );
                if (item.numericValue == "decimal")
                  deci.push(
                    !Number.isInteger(Number(item.value[0]))
                      ? item.value[0]
                      : ""
                  );
                if (item.dropdownDeafultValueCheck) {
                  beta.push(Number(item.value[0]) < 0 ? item.value[0] : "");
                }
                if (item.typename == "dates") {
                  maxiA.push(
                    new Date(item.value[0]) <= new Date(item?.numericValue[0])
                      ? item.value[0]
                      : ""
                  );
                  miniA.push(
                    new Date(item.value[0]) >= new Date(item.dropdownapi)
                      ? item.value[0]
                      : ""
                  );
                }
                if (item.typename == "times") {
                  maxiB.push(
                    item.value[0] <= item?.numericValue[0] ? item.value[0] : ""
                  );
                  miniB.push(
                    item.value[0] >= item.dropdownapi ? item.value[0] : ""
                  );
                }
              }
            }
          });
        }
      });
    });

    if (
      unique.filter((i) => i.length == 0).length < 1 &&
      maxi.filter((i) => i.length == 0).length < 1 &&
      mini.filter((i) => i.length == 0).length < 1 &&
      negi.filter((i) => i.length == 0).length < 1 &&
      alphab.filter((i) => i.length == 0).length < 1 &&
      alphanum.filter((i) => i.length == 0).length < 1 &&
      ints.filter((i) => i.length == 0).length < 1 &&
      deci.filter((i) => i.length == 0).length < 1 &&
      beta.filter((i) => i.length == 0).length < 1 &&
      maxiA.filter((i) => i.length == 0).length < 1 &&
      miniA.filter((i) => i.length == 0).length < 1 &&
      maxiB.filter((i) => i.length == 0).length < 1 &&
      miniB.filter((i) => i.length == 0).length < 1
    ) {
      setwaits(true)
      let newFormView = { ...viewForm, mandatory: false };
      setviewForm(newFormView);
      saveFormApplication(first);
    } else {
      setwaits(false)
      setviewForm(newFormView);
      autoSaveForm(first, appID, newFormView.mandatory)
      toast.error("Please fill all required form fields to submit *");
    }
  };

  const [counter, setcounter] = useState(0);

  return (
    <LoadingComponent isLoading={formDetailsLoading}>
      <Application
        formDetails={formDetails}
        formId={formId}
        first={first}
        setfirst={setfirst}
        handleApplicationSave={handleApplicationSave}
        setviewForm={setviewForm}
        viewForm={viewForm}
        setcounter={setcounter}
        counter={counter}
        retFind={retFind}
        modalShow={modalShow}
        setModalShow={setModalShow}
        viewFormAction={viewFormAction}
        appID={appID}
        subFlag={subFlag}
        queryParams={queryParams}
        waits={waits}
      />
    </LoadingComponent>
  );
};

export default FormApplication;
